import {
  Box,
  Button,
  Container,
  InputLabel,
  Paper,
  TextField,
  Typography,
  Autocomplete,
  Select,
  MenuItem
} from "@mui/material";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Navbar from "../../../components/Navbar";
import HeaderSteps from "../../../components/auth/HeaderSteps";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import Cookies from "js-cookie";
import countries from "../../../data/countries";
import PhoneInput from "react-phone-input-2";

export default function StudentFirstStep() {
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      fullName: "",
      email: "",
      phone: "",
      place: "",
    },
  });

  const { t } = useTranslation();
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const lang = Cookies.get("i18next") || "en";

  useEffect(() => {
    window.navigator.geolocation.getCurrentPosition(
      (position) => {
        localStorage.setItem("latitude", position.coords.latitude);
        localStorage.setItem("longitude", position.coords.longitude);
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  async function onSubmit(data) {
    closeSnackbar();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_KEY}api/v1/student/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: data.email,
            name: data.fullName,
            location: data.place,
            phoneNumber: "+" + data.phone,
            lang: lang,
          }),
        }
      );
      const resData = await response.json();
      console.log(resData);
      
      if (response.status !== 200 && response.status !== 201) {
        enqueueSnackbar(
          lang === "ar" ? resData.error.arabic : resData.error.english,
          { variant: "error", autoHideDuration: "8000" }
        );
        throw new Error("failed occured");
      }
      localStorage.setItem("studentEmail", data.email);
      navigate("/studentregister/step2");
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <Navbar>
      <Container sx={{ marginTop: "110px" }}>
        <Paper
          sx={{
            width: { md: "450px" },
            padding: "30px 50px",
            margin: "60px auto 60px",
          }}
        >
          <HeaderSteps step={1} title={t("newAccount")} steps={4} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ marginBottom: "30px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "13px" }}>
                {t("fullname")}
              </InputLabel>
              <Controller
                name="fullName"
                control={control}
                render={({ field }) => (
                  <TextField type="text" {...field} fullWidth />
                )}
                {...register("fullName", {
                  required: "fullName Address is required",
                })}
              />
              {errors.fullName?.type === "required" && (
                <Typography
                  color="error"
                  role="alert"
                  sx={{ fontSize: "13px", marginTop: "6px" }}
                >
                  {t("required")}
                </Typography>
              )}
            </Box>
            <Box sx={{ marginBottom: "30px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "13px" }}>
                {t("email")}
              </InputLabel>
              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <TextField type="text" {...field} fullWidth />
                )}
                {...register("email", {
                  required: "email Address is required",
                })}
              />
              {errors.email?.type === "required" && (
                <Typography
                  color="error"
                  role="alert"
                  sx={{ fontSize: "13px", marginTop: "6px" }}
                >
                  {t("required")}
                </Typography>
              )}
            </Box>
            {/* Added by Abdelwahab */}
            <Box sx={{ marginBottom: "26px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "13px" }}>
                {t("phone")}
              </InputLabel>
              <Box sx={{ direction: "rtl" }}>
                <Controller
                  name="phone"
                  control={control}
                  render={({ field }) => <PhoneInput {...field} />}
                  {...register("phone", {
                    required: "Phone Number is required",
                  })}
                />
                {errors.phone?.type === "required" && (
                  <Typography
                    color="error"
                    role="alert"
                    sx={{ fontSize: "13px", marginTop: "6px" }}
                  >
                    {t("required")}
                  </Typography>
                )}
              </Box>
            </Box>
            {/* ------------------- */}
            <Box sx={{ marginBottom: "30px" }}>
              {/* <InputLabel sx={{ marginBottom: "6px", fontSize: "13px" }}>
                {t("place")}
              </InputLabel> */}
              {/* <Controller
                name="place"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    fullWidth
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    MenuProps={{
                      elevation: 1,
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 3 + 8,
                          width: 160,
                        },
                      },
                    }}
                    {...register("place", { required: "place is required" })}
                    renderValue={(selected) => {
                      const selectedCountry = countries.find((op) => op.code === selected);
                      return selectedCountry ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={`https://flagcdn.com/w320/${selectedCountry.code}.png`}
                            width={30}
                            style={{ marginLeft: 8 }}
                            alt=""
                          />
                          <span>{lang === "en" ? selectedCountry.name_en : selectedCountry.name_ar}</span>
                        </div>
                      ) : (
                        ""
                      );
                    }}
                  >
                    {countries.map((op, index) => (
                      <MenuItem key={index + "mjnnj"} value={op.code} style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={`https://flagcdn.com/w320/${op.code}.png`}
                          width={30}
                          style={{ marginLeft: 8 }}
                          alt=""
                        />
                        <span>{lang === "en" ? op.name_en : op.name_ar}</span>
                      </MenuItem>
                    ))}
                  </Select>
                )}
              /> */}
<Controller
  name="place"
  control={control}
  render={({ field }) => (
    <Autocomplete
      options={countries}
      getOptionLabel={(option) =>
        lang === "en" ? option.name_en : option.name_ar
      }
      onChange={(_, data) => {
        field.onChange(data?.code || "");
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("place")}
          error={!!errors.place}
          helperText={errors.place ? t("required") : ""}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} style={{ display: "flex", alignItems: "center" }}>
          <img
            src={`https://flagcdn.com/w320/${option.code}.png`}
            width={30}
            style={{ marginLeft: 8 }}
            alt=""
          />
          <span>
            {lang === "en" ? option.name_en : option.name_ar}
          </span>
        </li>
      )}
    />
  )}
  rules={{ required: "place is required" }}
/>
{/* 
              {errors.place?.type === "required" && (
                <Typography
                  color="error"
                  role="alert"
                  sx={{ fontSize: "13px", marginTop: "6px" }}
                >
                  {t("required")}
                </Typography>
              )} */}
            </Box>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              type="submit"
              sx={{ textTransform: "capitalize" }}
            >
              {t("register")}
            </Button>
          </form>
          <Typography
            sx={{
              marginTop: "20px",
              fontSize: "14px",
              textAlign: "center",
              fontWeight: "700",
              marginBottom: "20px",
            }}
          >
            {t("haveanaccount")}
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={() => navigate("/login")}
          >
            {t("login")}
          </Button>
        </Paper>
      </Container>
    </Navbar>
  );
}
